<template>
  <div class="transaction-management">
    <div v-show="(toVeriQueryShow == false && fromFrame == false && !toSmsVerifi)">
      <el-container
        class="absolute-el-con"
        :class="dataGenerate ? '' : 'min-box-1200'"
        :style="dataGenerate ? 'top: 48px': (isNav ? 'top:101px;' : '')"
		v-loading.fullscreen="fullScreenLoading"
      >
        <template v-if="isPersonal">
          <treeMenu
            :menuData="menuData"
            v-on:childTreeMethods="childTreeMethods"
            v-on:searchMenuData="searchMenuData"
            v-if="fromFrame"
          ></treeMenu>
        </template>
        <el-main class="nopadding">
          <transactionManagementList
            ref="oneChild"
            :navIndex="0"
            :activeTypeName="activeName"
            :parentQuery="parentQuery"
            :approvalId="approvingId || approvalId"
            :fileProperty="fileProperty"
            :aitableHide="aitableHide"
            @sourceAudit="sourceAudit"
            @resetRefresh="resetRefresh"
            @smsVerifi="smsVerifiFun"
            v-show="activeName === 0"
          >
          </transactionManagementList>

          <transactionManagementList
            ref="twoChild"
            :navIndex="1"
            :fileProperty="fileProperty"
            :parentQuery="parentQuery"
            :activeTypeName="activeName"
            :approvalId="approvingId || approvalId"
            :batchadd="batchadd"
            :aitableHide="aitableHide"
            @sourceAudit="sourceAudit"
            @resetRefresh="resetRefresh"
            @smsVerifi="smsVerifiFun"
            v-show="activeName === 1"
          >
          </transactionManagementList>

          <transactionManagementList
            ref="threeChild"
            :navIndex="2"
            :fileProperty="fileProperty"
            :parentQuery="parentQuery"
            :activeTypeName="activeName"
            :approvalId="approvingId || approvalId"
            :aitableHide="aitableHide"
            @sourceAudit="sourceAudit"
            @resetRefresh="resetRefresh"
            @smsVerifi="smsVerifiFun"
            v-show="activeName === 2"
          >
          </transactionManagementList>

          <transactionManagementList
            ref="fourthChild"
            :navIndex="3"
            :fileProperty="fileProperty"
            :parentQuery="parentQuery"
            :activeTypeName="activeName"
            :approvalId="approvingId || approvalId"
            :aitableHide="aitableHide"
            @sourceAudit="sourceAudit"
            @resetRefresh="resetRefresh"
            @smsVerifi="smsVerifiFun"
            v-show="activeName === 3"
          >
          </transactionManagementList>
          <!--                    5代办 6 已办 7 待阅-->

          <affairList
            ref="affair7"
            :approvalId="approvingId || approvalId"
            stat="1"
            :isLeft="true"
            searchTitle="筛选"
            @referHave="referHave"
            @retOpen="auitOpen"
            v-show="activeName === 7"
          />
        </el-main>
      </el-container>
    </div>
    <!-- 表单验证过滤 -->
    <VerificationAndQueryInput
      ref="VerificationAndQueryInputRef"
      :approvalId="$route.query.approvalId || approvingId"
      :number="1"
      @toVerificationAndQuery="formVerificationAndQuery"
      v-if="toVeriQueryShow == true"
    />
    <smsVerifiction
      ref="smsVerifi"
      :approvalId="$route.query.approvalId || approvingId"
      type="1"
      v-show="toSmsVerifi"
      @smsRefersh="smsRefersh"
    />
    <oa-examine-audit
      ref="AuditOpenChild"
      @sourceAudit="auditSourceAudit"
      v-if="isAudit"
    />
    <div v-html="cssFun()"></div>
  </div>
</template>

<script>
import { openapiValidateapprovalsms, getopenreportformlist, getvalidateapproval, getmyreportapprovallist } from '@/port/clientSide/workbench'
import treeMenu from '../common/treeMenu.vue';
import transactionManagementList from './transactionManagementList.vue';
import { searchNav } from '@/api/utils'
import VerificationAndQueryInput from '../VerificationAndQueryInput'
import affairList from './affairList.vue'
import smsVerifiction from '@/components/clientSide/common/smsVerifiction.vue'
import qs from 'qs'
import { getTMbulkImportParam } from '@/components/schoolInstrument/component/mutual/common/config'

// 查看
// import oaExamineAudit from '../oaExamineAudit.vue'
import {timeFormatDate} from "../../../api/global";

export default {
  name: 'organizationCpn',
  components: {
    treeMenu,
    transactionManagementList,
    // formDataModify,
    VerificationAndQueryInput,
    affairList,
    // oaExamineAudit,
    smsVerifiction
  },
  // external 存在就是外链
  props: ["listCount", "external", 'fileProperty', 'importSet', 'aitableHide', 'approvalId', 'dataGenerate', 'parentQuery'],
  data () {
    return {
      isNav: false, // 是否为头部留出空间
      fullScreenLoading: true,
      fromFrame: false,
      isPersonal: true,  //个人信息来的
      userId: true,//个人报表或者学校报表
      menuListActive: 0,
      menuData: [],//最左边树形菜单使用得数据
      menuListDatas: [],//中间菜单显示得数据
      query: [],//搜索列表数据
      querys: undefined,//验证过滤使用，如果有过滤数据，就走这个过滤
      searchMore: false,
      menuListW: false,
      firstSearch: { appname: '', status: '', statu: [], time: '' },
      tableKey: [],
      showSets: [],//显示设置全部
      checkShowSet: [],//显示设置选中
      isIndeterminate: true,//全选使用
      dialogFieldVisible: false,
      dialogFieldSet: {
        title: '设置导出字段',
        botton: 0,
      },
      checkAllField: false,
      userReportId: null,//提交显示字段ID
      listData: { data: [] },
      handleCurrent: 0,//分页tib页面
      // currentPage:1,//当前页码
      naxText: null,
      originalArr: null,
      tabSactive: 0,//我的数据和代办切换
      // tabsNavAr:["我的数据","我办理的"],
      activeName: 0,//- 设置dom显示      4:全部,0:我发起的,3:关于我的,1:待办的,2:已办的 5代办 6 已办 7 待阅

      loadIsTrueArr: [0, 0, 0, 0, 0],//判断是否加载过数据
      toVeriQueryShow: true,//- 是否开启过滤验证数据

      toSmsVerifi: false, // 是否开启短信验证
      info: {}, // 这个是待我处理等接口使用
      approvingId: '',  // 应用id
      isAudit: false, // 预览
      navArr: {   // 字典下标数据
        0: 1,
        // 5:2,
        // 6:4,
        7: 3,
        3: 5,
        1: 2,
        2: 4
      },
      // isLeft: true, // 是否显示左边列表
      isSmsFun: {},  // 是否验证过
      batchadd: false, // 是否开启批量审批
      // url 过来的打开搜索
      searchQuery: '',
      searchQueryKey: '',
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
  },
  methods: {
    cssFun () {
      const str = '<style>html, body, #app {height:calc(100% - 5px);}</style>';
      return !this.isNav ? str : '';
    },
    // 全部已读
    referHave () {
      this.$emit('refershRed');
    },
    // 打开后回来刷新
    auditSourceAudit () {
      // 只有待我处理回来的才需要刷新
      this.loadIsTrueArr = [2, 2, 2, 2, 2, 2, 2, 2];
      this.getInquireInfo(2);
      // 刷新红点
      this.$emit('refershRed');
      this.$emit('retRefresh');
    },
    // 打开参数
    auitOpen (e) {
      // 5代办 6 已办 7 待阅
      this.isAudit = true;
      let self = this;
      this.$nextTick(function () {
        if (self.activeName === 5) {
          this.$refs.AuditOpenChild.AuditOpenList(e, 5);
        } else if (self.activeName === 6) {
          this.$refs.AuditOpenChild.AuditOpenList(e, 0);
        } else if (self.activeName === 7) {
          this.$refs.AuditOpenChild.AuditOpenList(e, 4);
          // 刷新红点
          self.$emit('refershRed');
        }
      })
    },
    // 重置刷新
    resetRefresh (val) {
      // this.loadIsTrueArr = [2,2,2,2,2,2,2,2];
      // 把 1 重置成2
      for (let i = 0; i < this.loadIsTrueArr.length; i++) {
        if (this.loadIsTrueArr[i] === 1) this.loadIsTrueArr[i] = 2;
      }

      let key = this.navArr[this.activeName];
      if (key === 1 || key === 5) {
        this.activeNameChang(Number(key) === 1 ? 0 : Number(key) === 5 ? 3 : '');
      } else {
        this.getInquireInfo(key);
        this.loadIsTrueArr[this.activeName] = 1;
      }
      // 更新红点数据
      this.$emit('refershRed');
      if (val && val === 'del') this.$emit('retRefresh')
    },
    // 刷新数据
    getInquireInfo (key) {
      let self = this;
      this.$nextTick(function () {
        if (Number(key) === 2) {
          // 5代办
          this.loadIsTrueArr[1] = 0
          this.activeNameChang(1);
        } else if (Number(key) === 3) {
          let dom = this.$refs.affair7;
          if (dom) {
            dom.initialization(self.info.affair, 'ccapproval');
          }
        } else if (Number(key) === 4) {
          // 6 已办
          this.loadIsTrueArr[2] = 0
          this.activeNameChang(2);
        }
      });
    },
    // 统一分类查询
    inquire (key) {
      if (Number(key) === 1 || Number(key) === 5) {
        this.activeNameChang(Number(key) === 1 ? 0 : Number(key) === 5 ? 3 : '');
      } else if (Number(key) === 2 || Number(key) === 4) {
        // 2 代办 4 已办
        this.activeName = Number(key) === 2 ? 5 : 4;
        this.activeNameChang(Number(key) === 2 ? 1 : 2);
      } else {
        // 切换内容 5代办 6 已办 7 待阅
        this.activeName = Number(key) === 2 ? 5 : Number(key) === 3 ? 7 : 6;
        const listIndex = this.loadIsTrueArr[this.activeName];
        // 固定请求参数初始化
        this.info.affair = {
          curpage: 1,
          pagesize: 6,
          way: '0,1,2,4',
          approvalId: this.$route.query.approvalId || this.approvingId || this.approvalId
        };

        if (Number(key) === 2) {
          this.info.affair.type = 1;
          this.info.affair.status = 0;
        } else if (Number(key) === 3) {
          this.info.affair.type = 1; // 此状态为当前固定参数
          this.info.affair.status = 0; // 这个根据点击变动
        } else if (Number(key) === 4) {
          this.info.affair.type = 1;
          this.info.affair.status = '1,2';
        }

        if (listIndex === 0 || listIndex === 2) {
          this.getInquireInfo(key);
          this.loadIsTrueArr[this.activeName] = 1;
        }
      }
    },
    activeNameChang (res) {
      // 4:全部,0:我发起的,3:关于我的,1:待办的,2:已办的
      this.activeName = res;
      let thisTy = this.loadIsTrueArr[res];
      console.log(thisTy,'thisTythisTythisTy')
      if (res === 4) {
        // this.$refs.fiveChild.obtainHeight(res);
      } else if (res === 0) {
        if (thisTy === 0) {
          //我发起的
          this.menuListDatas.forEach((el) => {
            if (el.userId) {
              const obs = { type: 0, curpage: 1, pagesize: 25, cateId: "-1", key: "", querys: this.querys || '{}', query: this.searchQuery || '{}' }
              if (this.searchQueryKey || this.searchQueryKey === 0) {
                obs.key = this.searchQueryKey
              }
              this.$refs.oneChild.menuListMethod(el, obs, 0);
            }
          });
        }
        if (thisTy === 0 || thisTy === 2) {
          this.$refs.oneChild.getDataList(0);
        }
        this.$refs.oneChild.obtainHeight(res);
      } else if (res === 3) {
        //关于我的
        if (thisTy === 0) {
          this.menuListDatas.forEach((el) => {
            if (el.userId) {
              const obs = { curpage: 1, pagesize: 25, cateId: "-1", key: "", selfuser: 0, querys: this.querys, query: this.searchQuery || '{}' }
              if (this.searchQueryKey || this.searchQueryKey === 0) {
                obs.key = this.searchQueryKey
              }
              this.$refs.fourthChild.menuListMethod(el, obs, 0);
            }
          });
        }
        if (thisTy === 0 || thisTy === 2) this.$refs.fourthChild.getDataList(0);
        this.$refs.fourthChild.obtainHeight(res);
      } else if (res === 1) {
        //待办的
        if (thisTy === 0) {
          this.menuListDatas.forEach((el) => {
            if (el.userId) {
              const obs = { type: 1, curpage: 1, cateId: -1, pagesize: 25, key: "", status: '0', querys: this.querys, way: '0,1,2,4', query: this.searchQuery || '{}' }
              if (this.searchQueryKey || this.searchQueryKey === 0) {
                obs.key = this.searchQueryKey
              }

              this.$refs.twoChild.menuListMethod(el, obs, 0, 0);
            }
          });
        }
        if (thisTy === 0 || thisTy === 2) {
          this.$refs.twoChild.getDataList(0);
        }
        this.$refs.twoChild.obtainHeight(res);
      } else if (res === 2) {
        //已办的
        if (thisTy === 0) {
          this.menuListDatas.forEach((el) => {
            if (el.userId) {
              const obs = { type: 1, way: "0,1,2,4", status: '1,2', curpage: 1, pagesize: 25, key: "", querys: this.querys, query: this.searchQuery || '{}' }
              if (this.searchQueryKey || this.searchQueryKey === 0) {
                obs.key = this.searchQueryKey
              }

              this.$refs.threeChild.menuListMethod(el, obs, 0);
            }
          });
        }
        if (thisTy === 0 || thisTy === 2) this.$refs.threeChild.getDataList();
        this.$refs.threeChild.obtainHeight(res);
      }
      this.loadIsTrueArr[res] = 1;//判断是否加载过数据
    },

    searchMenuData (val) {
      if (this.originalArr && this.originalArr.length !== '') {
        this.menuData = searchNav(this.originalArr, val)
      }
    },
    childTreeMethods (param) {
      if (param.categoryName && param.appname) {
        this.naxText = {
          father: param.categoryName,
          child: param.appname
        }
      }
      //切换回我的数据
      if (this.tabSactive === 1) {
        this.tabSactive = 0;
      }
      const spaceid = this.$route.query.spaceid
      const upaceid = this.$route.query.upaceid
      const __par = { curpage: 0, pagesize: 0, approvalId: param.approvalId }
      if (spaceid) {
        __par.spaceid = spaceid
      }
      else if (upaceid) {
        __par.upaceid = upaceid
      }
      if (this.$route.query.space) {
        delete __par.spaceid
        __par.spaceid = spaceid || localStorage.getItem('spaceid')
      }
      else if (this.$route.query.upace) {
        delete __par.upaceid
        __par.upaceid = upaceid || localStorage.getItem('upaceid')
      }
      getopenreportformlist(__par).then(res => {
        this.fullScreenLoading = false;
        if (res && res.code == 0) {
          this.menuListDatas = res.data;
          this.loadIsTrueArr = [0, 0, 0, 0, 0, 0, 0, 0, 0];//设置回默认状态是否加载过
          res.data.forEach(e => {
            if (e.userId) {
              this.inquire(this.navArr[this.activeName]);
              if (e.batchadd) this.batchadd = true
            }
          });
          //默认都需要设置。要不然会导致数据错误。因为拿默认来判断是否加载过
        }
      }).catch(() => {
        // TODO
      })
    },
    async sourceAudit (param) {//来源transactionManagementList.vue的方法
      if (param.key == 0) {
        this.secondData.data.forEach((el, index) => {
          if (el.userapprovingId == param.userapprovingId) {
            this.secondData.data.splice(index, 1);
            this.secondnum = this.secondnum - 1;
          }
        });
        this.thirdData = null;
      } else if (param.key === 1) {
        var approvalId = this.menuListDatas[0].approvalId;
        const obj = await getTMbulkImportParam(approvalId, false, this.importSet)
        if (obj && obj.openType !== 'old' && obj.openType !== 'new') {
          this.$emit('open-appDialog', obj)
        }
      } else if (param.key === 2) {
        let queryParam = {
          approvalId: this.menuListDatas[0].approvalId,
          modifyId: param.data.approvingId,
          person: 1,
        };
        //是否显示头部
        if (this.fromFrame) {
          queryParam.type = 1
        }
        // 修改去上一层组建走
        this.$emit('upInput', queryParam);
      }
    },
    formVerificationAndQuery (data) {
      this.querys = data && data.querys ? data.querys : "{}";
      if (this.external) {
        this.toVeriQueryShow = false;
        this.judgeScene();
      } else {
        // 去走是否需要短信验证
        this.smsVerifi(1);
      }
    },
    // 里面页面回来的批量导出
    smsVerifiFun (e) {
      this.transactionListFun = e;

      // 如果验证过则不需要再次验证
      if (this.isSmsFun[e] || this.external) {
        this.smsRefersh();
        return false;
      }
      // 存储触发方法（因为是不关联页面的值所以直接存储）
      let key = e === 'batchFileFun' ? 2 : 3;
      this.smsVerifi(key);
    },
    //- 表单·获取列表
    whetherShow (type) {
      //type这个是判断是iframe提交后更新数据
      let para = {
        approvalId: this.$route.query.approvalId || this.approvingId || this.approvalId,
        number: type,
      };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        para.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        para.upaceid = upaceId
      }
      getvalidateapproval(para).then(res => {
        if (res.data.property && res.data.property.length>0) {
          this.fullScreenLoading = false;
          this.toVeriQueryShow = true;
          this.$nextTick(() => {
            this.$refs.VerificationAndQueryInputRef.showList(res);
          })
        } else {
          //- 说明不需要开启验证(如果是外链直接过)
          if (this.external) {
            this.toVeriQueryShow = false;
            this.judgeScene();
          } else {
            // 填写验证不开启，查询短信验证是否开启
            this.smsVerifi(1);
          }
        }
      }).catch(err => {
        console.log('getapproval 接口出错', err)
      })
    },
    // 短信验证
    smsVerifi (key) {
      let obj = {
        approvalId: this.$route.query.approvalId || this.approvingId || this.approvalId,
        number: key // 验证参数为 1	个人数据查看短信验证 2 个人数据批量导出附件短信验证 3 个人数据批量导出报表短信验证 4 全校数据查看短信验证 5 全校数据批量导出附件短信验证 6 全校数据批量导出报表短信验证
      }
      openapiValidateapprovalsms(obj).then(res => {
        if (res.code === 0) {
          // bindcode 是否需要绑定手机号 smsverification 是否需要短信验证 phone 手机号
          if (res.data.smsverification && res.data.bindcode && !res.data.phone) {
            // 去绑定手机号
            this.fullScreenLoading = false;
            if (!this.transactionListFun) this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.iphoneBind({ isSmsView: true });
            })
          } else if (res.data.smsverification && res.data.phone) {
            // 去验证
            this.fullScreenLoading = false;
            if (!this.transactionListFun) this.toSmsVerifi = true;
            this.$nextTick(() => {
              this.$refs.smsVerifi.openSmsVer(res.data.phone, this.toSmsVerifi ? { isSmsView: true } : '');
            })
          } else {
            // 不需要验证
            if (key !== 1) {
              this.$nextTick(() => {
                // let refa = Number(this.activeName) === 0 ? 'oneChild' : 'fourthChild';
                const obj = {
                  0: 'oneChild',
                  1: 'twoChild',
                  2: 'threeChild',
                  3: 'fourthChild'
                }
                const refa = obj[this.activeName]
                this.$refs[refa][this.transactionListFun](this.transactionListFun === 'getuserreport' ? 0 : '');
              })
            } else {
              this.toVeriQueryShow = false;
              this.judgeScene();
            }
          }
        }
      }).catch(err => {
        console.log('短信验证错误', err)
      })
    },
    // 短信验证返回
    smsRefersh () {
      // 如果是点击了按钮的
      if (this.transactionListFun) {
        this.isSmsFun[this.transactionListFun] = true;
        this.$nextTick(() => {
          let refa = Number(this.activeName) === 0 ? 'oneChild' : 'fourthChild';
          this.$refs[refa][this.transactionListFun](this.transactionListFun === 'getuserreport' ? 0 : '');
          delete this.transactionListFun;
        })
      } else {
        this.toSmsVerifi = false;
        // this.querys = e && e.querys ? e.querys : "{}";
        this.toVeriQueryShow = false;
        this.judgeScene();
      }
    },
    //- 正常流程场景操作
    judgeScene () {
      if (this.$route.query.approvalId || this.approvingId || this.approvalId) {
        // this.fullScreenLoading=false;
        this.childTreeMethods({ approvalId: this.$route.query.approvalId || this.approvingId || this.approvalId })
        //个人信息过来的
        if (this.$route.query.personal) {
          this.isPersonal = false;
        } else {
          // this.fromFrame=true;
        }
        return false;
      }
      getmyreportapprovallist({ curpage: 0, pagesize: 0, cateId: "-1" }).then(res => {
         // this.fullScreenLoading=false;
        if (!res.data || res.data.length == 0) {
          return
        }
        this.toVeriQueryShow = false;
        this.originalArr = JSON.parse(JSON.stringify(res.data))
        let a = searchNav(res.data)
        this.menuData = a;
        a[0].value[0] ? this.childTreeMethods(a[0].value[0]) : ''
      }).catch(() => {
        // TODO
      })
    },
    // 当前页面组建引用形式触发
    getList (id) {
      // 重置组建值
      this.toVeriQueryShow = false;
      this.approvingId = id;
      this.fullScreenLoading = true;
      this.toSmsVerifi = false;
      this.isSmsFun = {};
      if (this.transactionListFun) delete this.transactionListFun;
      this.whetherShow(1);
    }
  },

  mounted () {
    const url = window.location.href;
    if ((url.indexOf('/clientSide/workbench/transactionManagement') !== -1 && this.$route.query.approvalId) || (this.dataGenerate && this.approvalId)) {
      this.whetherShow(1);
      this.isNav = true;
    }
    // 如果有搜索条件的话直接过来搜索
    const searchStr = window.location.search ? (window.location.search).substring(1) : ''
    // const { search, approvalId } = this.$route.query
    if (searchStr) {
      let { search, approvalId } = qs.parse(searchStr)
      if (search) {
        search = JSON.parse(search)
        const obs = {}
        // const approvalId = Number(approvalId)
        // const key = []
        const obj = {
          '状态_status': 'status_status',
          '提交时间_date': 'date_timeof',
          '归档状态_status': 'archive_radio',
          '申请人_relation-user': 'appuser_appuser'
        }
        const statusObj = {
          '待审批': 0,
          '已通过': 1,
          '未通过': 2,
          '已撤回': 3
        }

        if (search.relevanceRules && search.relevanceRules.length > 0) {
          for (const i of search.relevanceRules) {
            if (Number(i.formid) === approvalId && i.datas && i.datas.length > 0) {
              for (const a of i.datas) {
                if (a.target && a.target !== '申请人_relation-user' && a.target !== '单号_text') {
                  // 状态、提交时间、归档状态格式不太一样，转化以下
                  const target = obj[a.target] || a.target
                  obs[target] = a.value
                }
              }
            }
          }
          // 查询下一级数据进行存放 searchCriteria.query
          // this.querys = obs
          this.searchQuery = obs
        } else {
          const obs = {}
          for (const i in search) {
            const val = Array.isArray(search[i]) ? search[i] : [search[i]]
            delete obj['状态_status']
            delete obj['提交时间_date']
            // 为空的值直接删掉
            if (!search[i] && search[i] !== 0) continue
            // 数字值处理下
            if (i === 'status_status') {
              for (let s = 0; s < val.length; s++) {
                val[s] = statusObj[val[s]] || val[s]
              }
            } else if (i === 'date_timeof') {
              for (let s = 0; s < val.length; s++) {
                val[s] = timeFormatDate(new Date(val[s]).getTime())
              }
              if (val.length === 1) {
                val.push(val[0])
              }
            }
            if (obj[i]) {
              obs[obj[i]] = val
            } else {
              obs[i] = val
            }
          }
          this.searchQuery = obs
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tmTibs .el-tabs__nav {
  margin-left: 30px;
  padding: 10px 0;
}
.tmTibs .el-tabs__nav .el-tabs__item {
  font-size: 16px;
  color: #333333;
}
.el-table .header_style {
  background: #f8f9fb;
}
.row_style {
  color: #000;
}
.transaction-management .el-tabs__active-bar {
  background-color: #ffd323;
  height: 4px;
}
</style>
<style lang="scss" scoped>
.all-center {
  display: flex;
  align-items: self-start;
  height: 100%;
}
.personal-class {
  padding-bottom: 10px;
}
.el-main {
  background: #fff;
  position: relative;
}

.menuList {
  background: #f4f4f9;
  height: 100%;
  position: relative;
  z-index: 99;
}

.menuList > p {
  position: absolute;
  background: #fff;
  width: 26px;
  height: 26px;
  right: -13px;
  border-radius: 50%;
  border: 1px solid #ddd;
  top: 46%;
  cursor: pointer;
  z-index: 5;
  text-align: center;
  line-height: 26px;
}

.menuList > p i {
  color: #4e86ff;
  font-size: 14px;
}

.menuList ul {
  padding-top: 18px;
  overflow: hidden;
}

.menuList ul li {
  margin-right: 10px;
  display: block;
  padding: 10px 0 10px 42px;
  cursor: pointer;
  color: #333;
}

.menuList ul li.active {
  background: #d2d2e1;
  color: #000;
}

.menuList ul li:hover {
  background: #e0e0eb;
}
.demo-form-inline {
  float: left;
}

.page {
  position: absolute;
  bottom: 0;
  border-top: 1px solid #ddd;
  right: 0;
  width: 96%;
  text-align: right;
  background: #fff;
  z-index: 5;
}

.el-icon--right {
  padding: 0 10px;
}

.nopadding {
  padding: 0;
}

.dialog-body {
  padding: 16px;
}

.dialog-body .el-checkbox {
  padding-bottom: 12px;
}

.dialog-foot {
  padding: 10px 16px;
  border-top: 1px solid #eee;
}

.searchRow {
  height: 40px;
  overflow: hidden;
}

.searchBtn p {
  width: 90%;
  margin: 0 auto 10px;
}

.searchBtn p .el-button {
  width: 100%;
}

.searchList {
  height: 40px;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.searchMore {
  text-align: center;
  font-size: 20px;
  color: #4e86ff;
}

.searchMore i {
  cursor: pointer;
}
.bread-crumbs {
  font-size: 14px;
  color: #000;
  padding-bottom: 10px;
  padding-left: 18px;
  float: right;
}
.bread-crumbs span:nth-child(2) {
  margin-left: 15px;
}
.bread-crumbs span {
  margin-right: 15px;
}
.top-head,
.top-head2 {
  height: auto;
  display: inline-block;
  clear: both;
  margin-bottom: 5px;
}
.top-head .tabs-nav {
  width: 244px;
  height: 32px;
  float: left;
  overflow: hidden;
  border-radius: 4px;
}
.tabs-nav li {
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  float: left;
  cursor: pointer;
  background-color: white;
  border: 1px solid #eaeaea;
}
.tabs-nav li.active {
  color: white;
  // background-color: $base-color;
}
.top-head .naxText-class {
  margin-left: 80px;
  height: 30px;
  line-height: 30px;
  float: left;
}
</style>
